export enum PriceSection {
  "voices" = "voices",
  "humans" = "humans",
  "image" = "image",
  "studio" = "studio",
}
